import { ioExtend, ioGuid, QueryParams } from '@framework';

export class ProjectModel {
    ProjectID: string = null;
    Project: string = null;
    TranslationCode: string = null;
    Description: string = null;

    isNew = true;

    constructor(_project?: {}) {
        if (_project) {
            this.isNew = false;
        } else {
            this.ProjectID = ioGuid.New();
        }
        ioExtend(this, _project);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}

export class ProjectRouteModel {
    ProjectID: string = null;
    ProjectRouteID: string = null;
    Route: string = null;
    Methods: ProjectRouteMethodModel[] = [];

    isNew = true;

    constructor(_route?: {}) {
        if (_route) {
            this.isNew = false;
        } else {
            this.ProjectRouteID = ioGuid.New();
        }
        ioExtend(this, _route);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}

export class ProjectRouteMethodModel {
    Method: string = null;
    Value: boolean = null

    constructor(_method: {}) {
        ioExtend(this, _method);
    }
}

export class ProjectMenuModel {
    ProjectID : string = null;
    MenuRouteID : string = null;
    MenuRouteParentID : string = null;
    path : string = null;
    title : string = null;
    icon : string = null;
    Route : string = null;
    class : string = null;
    badge : string = null;
    badgeClass : string = null;
    isExternalLink : boolean = null;

    isNew = true;

    constructor(_menu?: {}) {
        if (_menu) {
            this.isNew = false;
        } else {
            this.MenuRouteID = ioGuid.New();
        }
        ioExtend(this, _menu);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}

export class ProjectInstanceModel {
    ProjectID : string = null;
    InstanceID : string = null;
    Instance : string = null;

    isNew = true;

    constructor(_instance?: {}) {
        if (_instance) {
            this.isNew = false;
        } else {
            this.InstanceID = ioGuid.New();
        }
        ioExtend(this, _instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}